<template lang="pug">
v-toolbar(
  color="#FFFFFF"
  dense
  fixed
  clipped-left
  clipped-right
  app
)#main-toolbar.pl-1
  v-btn(icon @click="showDashboardView")
    v-icon home
  v-toolbar-side-icon(
    v-if="!appearance.isFullScreen"
    @click.stop="toggleSideNav"
  )
  v-btn(
    v-if="appearance.isFullScreen"
    dark
    flat
    @click.stop="goBack"
  )
    v-icon chevron_left
    span Back
  //- div.mt-2.ml-2
  //-   a(@click="showDashboardView")
  //-     img(
  //-       src="../../resources/assets/logo-small-white.png"
  //-       alt="Logo"
  //-     ).logo
  //-     img(
  //-       src="../../resources/assets/csph-white.png"
  //-       alt="Logo"
  //-     ).mobilelogo
  //- v-spacer
  //- v-layout(
  //-   row
  //-   align-center
  //-   justify-center
  //-   style="max-width: 550px"
  //- )
  //-   v-text-field(
  //-     placeholder="Search..."
  //-     single-line
  //-     append-icon="search"
  //-     @click:append="() => {}"
  //-     class="white--text"
  //-     hide-details
  //-     dark
  //-     v-model="search"
  //-     clearable
  //-     color="#fff"
  //-   ).pt-0
  v-spacer
  v-btn(icon @click.native="showSearch()")
    v-icon search
  v-menu(bottom offset-y transition="slide-y-reverse-transition")
    v-btn(icon slot="activator")
      v-icon settings
    v-list
      template(v-if="isAllowedTo(4) || isAllowedTo(3) || isAllowedTo(2)")
        v-list-tile(@click="showSettingsView" v-if="isAllowedTo(4)")
          v-icon(light class="mr-2") settings
          v-list-tile-title Settings
        v-list-tile(@click="showContextView" v-if="hasAccess('contextviewaccessTable')")
          v-icon(light class="mr-2") view_list
          v-list-tile-title Context
        v-list-tile(@click="showGroupAdminView" v-if="isGroupAdmin()")
          v-icon(light class="mr-2") mouse
          v-list-tile-title Group Admin
        v-list-tile(@click="parentUpdate()")
          v-icon(light class="mr-2") update
          v-list-tile-title Check for Updates
        v-divider
      template(v-if="isAdminRole()")
        v-list-tile(@click="switchRole")
          v-icon(light class="mr-2") widgets
          v-list-tile-title {{viewMode}}
        v-divider
      v-list-tile(@click="logout")
        v-icon(light class="mr-2") power_settings_new
        v-list-tile-title Log out
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';
import * as types from '@/store/mutationTypes';
import sessionManager from '@/store/modules/session/sessionManager';

export default {
    name: 'AppHeader',

    computed: {
        ...mapState({
            appearance: state => state.appearance,
            client: state => state.client,
            role: state => state.session.role
        }),

        ...mapGetters({
            isAllowedTo: 'session/isAllowedTo',
            hasAccess: 'session/hasAccess'
        }),
        showSideNav: {
            get() {
                return this.$store.state.appearance.showSideNav;
            },

            set(value) {
                this.$store.commit(types.APPEARANCE_SET_SIDE_NAV, value);
            }
        },
    },

    data() {
        return {
            loading: false,
            items: [],
            search: null,
            showSearchNav: false,
            viewMode: 'Client User View'
        };
    },

    created() {
        this.showRoleNameLabel(this.role);
    },

    watch: {
        search(value) {
            this.setSearchText(value);

            // Show or close the search panel
            const show = value && value.length > 0;

            // Make sure to only toggle the search panel state
            if (show === this.appearance.showSearchPanel) return;

            this.setSearchPanel(show);
        },
        role(value) {
            this.showRoleNameLabel(value);
        }
    },

    methods: {
        ...mapMutations({
            setSearchPanel: types.APPEARANCE_SET_SEARCH_PANEL,
            setSearchText: types.APP_SET_SEARCH_TEXT
        }),

        showSearch() {
            this.setSearchPanel(true);
        },

        toggleSideNav() {
            this.$store.commit(types.APPEARANCE_TOGGLE_SIDE_NAV);
        },

        showSettingsView() {
            this.$router.push('/preferences/settings');
        },

        showContextView() {
            this.$router.push('/preferences/context');
        },

        showGroupAdminView() {
            this.$router.push('/preferences/groupAdmin');
        },

        isGroupAdmin() {
            const roleId = parseInt(this.role, 0);
            if (this.client.children && this.client.children.length > 0 &&
                (roleId === 3 || roleId === 4)) {
                return true;
            }
            return false;
        },

        showDashboardView() {
            this.$router.push('/');
        },

        isAdminRole() {
            const roleId = parseInt(this.role, 0);
            const originalRoleId = sessionManager.getOriginalAdminRoleFromLocalStorage();
            if (roleId > 1 || (roleId === 1 && parseInt(originalRoleId, 0) > 1)) {
                return true;
            }
            return false;
        },

        showRoleNameLabel(value) {
            const roleId = parseInt(value, 0);
            if (roleId > 1) {
                this.viewMode = 'Client User View';
            } else {
                const originalRoleId = sessionManager.getOriginalAdminRoleFromLocalStorage();
                switch (parseInt(originalRoleId, 0)) {
                    case 2:
                        this.viewMode = 'Client Admin View';
                        break;
                    case 3:
                        this.viewMode = 'Group Admin View';
                        break;
                    case 4:
                        this.viewMode = 'CompliSpace Admin View';
                        break;
                    default:
                        this.viewMode = 'Client User View';
                        break;
                }
            }
        },

        switchRole() {
            const roleId = parseInt(this.role, 0);
            if (roleId === 1) { // back to admin role view
                const originalRoleId = sessionManager.getOriginalAdminRoleFromLocalStorage();
                sessionManager.saveOriginalAdminRole(null);
                sessionManager.saveUserRole(originalRoleId);
            } else { // go to client user view
                sessionManager.saveOriginalAdminRole(roleId);
                sessionManager.saveUserRole(1);
            }
            this.$store.commit(types.SESSION_SET_ROLE,
                sessionManager.getUserRoleFromLocalStorage());
            // refresh page
            this.$router.go(0);
        },

        logout() {
            if (this.loading) return;
            this.loading = true;

            this.$store.dispatch('session/logout')
            .then((response) => {
                this.loading = false;
                this.$router.push('/login');
            })
            .catch((error) => {
                this.loading = false;
                this.showErrorAlert(error.message);
            });
        },

        goBack() {
            this.$store.commit(types.APPEARANCE_SET_FULLSCREEN, false);
            this.$router.back();
        },

        parentUpdate() {
            this.$emit('parentFn');
        }
    }
};
</script>

<style scoped>
.logo {
  width: 250px;
}
.mobilelogo {
  display: none;
  width: 22px;
  height: 22px;
}
@media (max-width:768px){
  .logo {
    display: none;
  }
  .mobilelogo{
    display: inline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/AppHeader.vue